import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import app from "./app";
import { reducer as toastrReducer } from 'react-redux-toastr';
export default (function (history) { return combineReducers({
    app: app,
    toastr: toastrReducer,
    router: connectRouter(history),
}); });



//////////////////
// WEBPACK FOOTER
// ./src/reducers/index.ts
// module id = 269
// module chunks = 0